module.exports = __webpack_public_path__ + "img/photo-25.fb486c24.jpg";